export function initBlogPage(ctx) {
  if (!ctx.blogPage) {
    return;
  }

  const blogSection = document.querySelector("[data-blog-page-filter]");
  const filter = blogSection?.querySelector("#blog-filter");
  const cards = blogSection?.querySelectorAll(".blog-grid article");

  if (filter) {
    filter.addEventListener("change", () => {
      const value = filter.value;

      cards.forEach((card) => {
        const categories = card.dataset.category || "";

        if (!value || categories.split(" ").includes(value)) {
          card.style.display = "";
        } else {
          card.style.display = "none";
        }
      });

      window.dispatchEvent(new Event("resize"));
    });
  }
}
